import { get, toString } from 'lodash';

export const CONCIERGE_KEY = {
  LOCATION: 'location',
  REASON: 'reason',
  PARTNER: 'partner',
  CONTACT: 'contact',
};

export const generateSafeUrl = url =>
  (url.substring(url.length - 1) === '/' ? url : `${url}/`);

// Used in analytic events under the "content" key
export const generateStepAnalytics = (position, storage, content) => {
  const partner = storage.get(CONCIERGE_KEY.PARTNER);

  return {
    partnerId: toString(get(partner, 'id')),
    content: {
      ...content || {},
      'step-position': position,
    },
  };
};
